module.exports = __webpack_public_path__ + "images/howitworks-step3.0b6217b55f4c895dafd6efff3fd1a2e7.svg";